import React from 'react';

import { useEditMode } from '@wp-block-builder/editor/hooks';

import EditBody from './EditBody';
import PreviewBody from './PreviewBody';

export default function FormFields() {
  const [mode] = useEditMode();
  switch (mode) {
    case 'EDIT':
      return <EditBody />;
    case 'PREVIEW':
      return <PreviewBody />;
  }
}
